"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _formWrapper = _interopRequireDefault(require("../formWrapper.js"));
var _generateNewId = require("./helpers/generateNewId.js");
var _style = _interopRequireDefault(require("./style.css"));
var _plusCircle = _interopRequireDefault(require("cccisd-icons/plus-circle2"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var fields = ['list[].id'];
var Form = function Form(props) {
  var list = props.fields.list;
  var Link = props.Link;
  var addHelpCenter = function addHelpCenter() {
    list.addField({
      id: (0, _generateNewId.generateStringId)({
        prefix: 'New Help Center',
        single: 'default',
        list: list
      }),
      showFaq: false,
      showChat: false,
      contact: {
        startsOpen: true,
        showContactText: 'I still need help...',
        contactText: 'Contact us:'
      },
      liveChat: {
        buttonText: 'Chat now',
        embedToken: ''
      },
      faq: {
        headerText: 'Frequently Asked Questions',
        limit: 3,
        showMoreText: 'Show more questions & answers...',
        showFewerText: 'Show fewer questions & answers...',
        questions: []
      }
    });
  };
  var removeHelpCenter = function removeHelpCenter(idx) {
    list.removeField(idx);
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].topActions
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary",
    type: "button",
    onClick: addHelpCenter
  }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], null), " Add help center")), /*#__PURE__*/_react["default"].createElement("table", {
    className: _style["default"].table
  }, /*#__PURE__*/_react["default"].createElement("tbody", null, list.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: item.id.value
    }, /*#__PURE__*/_react["default"].createElement("td", {
      className: _style["default"].name
    }, /*#__PURE__*/_react["default"].createElement(Link, {
      path: "list[".concat(index, "]")
    }, item.id.value)), /*#__PURE__*/_react["default"].createElement("td", {
      className: _style["default"].tableActions
    }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: /*#__PURE__*/_react["default"].createElement(_cross["default"], null),
      className: "btn btn-danger btn-xs",
      isConfirm: true,
      confirmationMessage: "Are you sure you want to delete this Help Center: ".concat(item.id.value, "?"),
      onClick: function onClick() {
        return removeHelpCenter(index);
      }
    })));
  }))));
};
var _default = exports["default"] = (0, _formWrapper["default"])({
  fields: fields
})(Form);